import React, { useMemo } from 'react';
import { useMedicalProfileDirectives } from '../../../../../../hooks/api/useMedicalProfileDirectives';
import {
    formValueToUpsertProfilePOARequest,
    getDefaultFromValue,
} from '../../../../../shared/Directives/POAFormFields';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { Form } from '../../../../../v2BaseComponents/Form';
import SideDrawerFormContainer from '../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import { getIntl } from '../../../../../../utils/intl';
import POAFormFields from '../../../../../shared/Directives/POAFormFields';

const intl = getIntl('EditPOASideDrawerContent', {
    save: 'Save',
    cancel: 'Cancel',
});

export type EditPOASideDrawerContentOwnProps = {
    medicalProfileId: string;
    onClose: (force: boolean) => void;
};

export type EditPOASideDrawerContentProps = EditPOASideDrawerContentOwnProps;

const EditPOASideDrawerContent: React.FC<EditPOASideDrawerContentProps> = ({ medicalProfileId, onClose }) => {
    const { isLoadingPOA, poa, updatePOA, isUpdatingPOA } = useMedicalProfileDirectives({
        medicalProfileId: medicalProfileId,
        onPOAUpdateSuccess: () => onClose(true),
    });
    const initialValue = useMemo(() => getDefaultFromValue(poa), [poa]);
    const isLoading = isLoadingPOA || isUpdatingPOA;
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <Form
                    fillContainer
                    initialValues={initialValue}
                    onSubmit={(values) => {
                        const upsertRequest = formValueToUpsertProfilePOARequest(values, poa);
                        updatePOA(upsertRequest);
                    }}
                    isDisabled={isLoading}
                    forceStackFields
                >
                    {({ isSubmitting, handleSubmit, values }) => {
                        return (
                            <SideDrawerFormContainer
                                isDisabled={isSubmitting || isLoading}
                                onSubmit={handleSubmit}
                                onCancel={() => onClose(true)}
                                saveText={intl('save')}
                                saveIcon="Check"
                            >
                                <POAFormFields values={values} />
                            </SideDrawerFormContainer>
                        );
                    }}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditPOASideDrawerContent);
